<template>
  <div class="container" :style="{'background-image': 'url('+bgUrl+')'}">
    <Menu/>
    <div class="home">
      <router-view />
    </div>
    <a-back-top />
    <Footer/>
  </div>
</template>

<script>
import Vue from "vue";
import { TENANT_CONFIG } from "@/store/mutation-types";
import Menu from "../components/Menu";
import Footer from "../components/Footer";
export default {
  name: "HomeLayout",
  components: {
    Menu,
    Footer,
  },
  data(){
    return{
      bgUrl: "/assets/background.svg"
    }
  },
  created(){
    const tenantConfig = Vue.ls.get(TENANT_CONFIG);
    if(tenantConfig.homeBackground){
      this.bgUrl = tenantConfig.themeConfig.homeBackground
    }
  }
};
</script>

<style lang="less" scoped>
.container{
  min-height: 100vh;
  // background: linear-gradient(
  //     180deg,
  //     rgb(59, 143, 238) 7%,
  //     rgb(155, 216, 243) 100%
  //   );
background: #f0f2f5 no-repeat 50%;
  .home{
    width:1200px;
    margin: auto
  }
}
</style>